<template>
    <sub-head v-bind="{ subVisualAttrs, tabsTag, tabsAttrs, tabTag, tabAttrs, ...$attrs }">
        <template #tit>
            <tit-primary class="white--text" titSize="tit--xl">
                <slot name="tit" />
            </tit-primary>
        </template>
        <slot />
    </sub-head>
</template>

<script>
import SubHead from "@/sets/styles/pages/sub-head.vue";
import TitPrimary from "@/components/publish/parents/typography/tit-primary.vue";

export default {
    props: {
        subVisualAttrs: { type: Object, default: () => ({}) },
        tabsTag: String,
        tabsAttrs: { type: Object, default: () => ({}) },
        tabTag: String,
        tabAttrs: { type: Object, default: () => ({}) },
    },
    components: {
        SubHead,
        TitPrimary,
    },
    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped></style>
